import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { UserTypes } from '@constants';
import { showErrorMessage } from '@services/notifyService';
import { setCacheAccessToken } from '@services/userService';
import { accountActions } from '@store/actions';
import { getRedirectPathAfterLogin } from '@utils/permission';

import LoginForm from './LoginForm';

// Port từ ra-log-monitor-cms/source/src/containers/account/LoginPage.js (class -> hook).
//
// Luồng NGUỒN — đăng nhập HAI BƯỚC bằng OTP, KHÔNG có 2FA TOTP/QR:
//   B1: submit tài khoản/mật khẩu -> action `login`
//        · responseData.result -> lưu `data.requestToken` vào state, tắt loading (ở lại trang,
//          form chuyển sang ô nhập OTP), KHÔNG điều hướng
//        · falsy/lỗi -> 'Tên đăng nhập hoặc mật khẩu không đúng. Vui lòng thử lại!'
//   B2: submit OTP -> action `loginOtp` với { ...valueForm, requestToken }
//        · có token -> lưu phiên -> kind ADMIN/EMPLOYEE -> điều hướng theo sitePathConfig
//        · không -> 'Mã OTP không chính xác. Vui lòng thử lại!'
//   Link "Quay lại đăng nhập" -> xoá requestToken, quay về bước 1.
//
// Tiêu đề trang đổi theo bước: 'ĐĂNG NHẬP' -> 'OTP'.
const LoginPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [requestToken, setRequestToken] = useState(null);

    const onLogin = (valueForm) => {
        setLoading(true);
        dispatch(
            accountActions.login({
                params: valueForm,
                onCompleted: (responseData) => {
                    if (responseData && responseData.result) {
                        setRequestToken(responseData.data?.requestToken);
                        setLoading(false);
                    } else {
                        setLoading(false);
                        showErrorMessage('Tên đăng nhập hoặc mật khẩu không đúng. Vui lòng thử lại!');
                    }
                },
                onError: () => {
                    setLoading(false);
                    showErrorMessage('Tên đăng nhập hoặc mật khẩu không đúng. Vui lòng thử lại!');
                },
            }),
        );
    };

    const onLoginOtp = (valueForm) => {
        setLoading(true);
        dispatch(
            accountActions.loginOtp({
                params: { ...valueForm, requestToken },
                onCompleted: (responseData) => {
                    if (responseData && responseData.token) {
                        setCacheAccessToken(responseData.token);
                        dispatch(accountActions.getProfileSuccess({ data: responseData }));
                        if (responseData.kind === UserTypes.ADMIN || responseData.kind === UserTypes.EMPLOYEE) {
                            navigate(getRedirectPathAfterLogin(responseData.permissions || []));
                        }
                    } else {
                        setLoading(false);
                        showErrorMessage('Mã OTP không chính xác. Vui lòng thử lại!');
                    }
                },
                onError: () => {
                    setLoading(false);
                    showErrorMessage('Mã OTP không chính xác. Vui lòng thử lại!');
                },
            }),
        );
    };

    const onBack = () => setRequestToken(null);

    return (
        <div className="auth-public-wrapper">
            <div className="login-container">
                <h1 className="page-title">{requestToken ? 'OTP' : 'ĐĂNG NHẬP'}</h1>
                <div className="login-content">
                    <LoginForm
                        onLogin={onLogin}
                        loading={loading}
                        onLoginOtp={onLoginOtp}
                        requestToken={requestToken}
                        onBack={onBack}
                    />
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
